import { render } from "./leftside.vue?vue&type=template&id=5a57d7a7&scoped=true"
import script from "./leftside.vue?vue&type=script&lang=js"
export * from "./leftside.vue?vue&type=script&lang=js"

import "./leftside.vue?vue&type=style&index=0&id=5a57d7a7&scoped=true&lang=scss"
import "./leftside.vue?vue&type=style&index=1&id=5a57d7a7&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a57d7a7"]])

export default __exports__